import React, {useRef, useState} from "react";
import Select, {defaultTheme, components} from 'react-select';
import makeAnimated from 'react-select/animated';
import { Box, Button, Card, CardActions, CardContent, CardOverflow, FormControl, FormHelperText, IconButton, Input, Stack, Tooltip, Typography } from "@mui/joy";
// import QueryBuilder, { RuleGroupType } from 'react-querybuilder';
// import { chakraControlElements } from '@react-querybuilder/chakra';
// import './MaestroMultiSearch.scss';
import MaestroSelect from "./MaestroSelect";
// import DatePicker from 'react-date-picker'
import MaestroSearchSelect from "./MaestroSearchSelect";
import { format } from "date-fns";
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const emptySearchGroup = {
    object: null,
    possibleOptions: null,
    options: []
};

const emptySearchObject = {
    'type': null,
    'operator': null,
    'value': null
};

export const operators = {
    'number': {
        '>': 'Greater Than',
        '<': 'Less Than',
        '=': 'Equals',
        '!=': 'Does Not Equal'
    },
    'number_between': {
        '>': 'Greater Than',
        '<': 'Less Than',
        '=': 'Equals',
        '!=': 'Does Not Equal',
        'between': 'Between'
    },
    'date': {
        '<': 'Before',
        '>': 'After',
        '=': 'On',
        '!=': 'Not On',
        'between': 'Between'
    },
    'relative_date': {
        '<': 'Before',
        '>': 'After',
        '=': 'On',
        '!=': 'Not On',
        'between': 'Between'
    },
    'contains': {
        'contains': 'Contains',
        'containsnot': 'Does Not Contain',
    },
    'has': {
        'has': 'Has',
        'hasnot': 'Does Not Have'
    },
    'involvement': {
        'has': 'Has',
        'hasnot': 'Does Not Have'
    },
    'boolean': {
        'true': 'Yes',
        'false': 'No',
    },
    'is': {
        '=': 'Equals',
        '!=': 'Does Not Equal',
    }
}

/*
const queryBuilderFields = [
    { name: 'firstName', label: 'First Name' },
    { name: 'lastName', label: 'Last Name' },
];
const [query, setQuery] = useState({ combinator: 'and', rules: [] }); //<RuleGroupType>
return (
  <QueryBuilder
    fields={queryBuilderFields}
    query={query}
    onQueryChange={q => setQuery(q)}
    controlElements={chakraControlElements}
    showCloneButtons
    enableDragAndDrop
    showCombinatorsBetweenRules
  />
);
*/

export const objectToSelectOptions = (obj) => {
    let arr = [];

    Object.entries(obj).map(item => {
        arr.push({
            label: item[1],
            value: item[0],
        });
    })

    return arr;
};

const MaestroMultiSearch = ({selectedCommunities, objects, searchTerms, dateRange, onChange}) => {
    const update = () => {onChange([...searchTerms]); /*console.log('update'); console.log(searchTerms)*/};
    //newSearchTerms

    // TODO: get cachable objects one time

    const addSearchGroup = () => {
        searchTerms.push({...emptySearchGroup});
        update();
    };

    const removeSearchGroup = (searchGroup) => {
        var i = searchTerms.indexOf(searchGroup);
        if(i != -1)
        {
            searchTerms.splice(i, 1);
        }

        update();
    };

    const addSearch = (searchGroup, searchObject = null) => {
        if(searchObject !== null) {
            searchGroup.options.push({...searchObject});
        } else {
            searchGroup.options.push({...emptySearchObject});
        }
        update();
    };

    const removeSearch = (searchGroup, search) => {
        var i = searchGroup.options.indexOf(search);
        if(i != -1)
        {
            searchGroup.options.splice(i, 1);
        }

        update();

        if(!searchGroup.options.length) {
            setTimeout(() => {
                addSearch(searchGroup);
            });
            // return; // return because addSearch() calls update on its own
        }

        // update();
    };

    const setSearchGroupType = (searchGroup, selected) => {
        searchGroup.object = selected;
        // default to contains for the ones we haven't set
        searchGroup.possibleOptions = selected.availableFields.map(field => {field.type = field.type || 'contains'; return field});//.filter(field => field.hasOwnProperty('type'));
        if(selectedCommunities.length > 1) {
            searchGroup.possibleOptions = searchGroup.possibleOptions.filter((item) => !item.hasOwnProperty('multi_community') || item.multi_community !== false); // true | 'only
        } else {
            searchGroup.possibleOptions = searchGroup.possibleOptions.filter((item) => !item.hasOwnProperty('multi_community') || item.multi_community !== 'only');
        }
        searchGroup.options = [];
        update();
        // todo: figure out a better way to do this
        // console.log(searchGroup);

        setTimeout(() => {
            // searchGroup.options = [{...emptySearchObject}];
            // update();
            addSearch(searchGroup);
        });

    };

    const getOperators = ($search, $type) => {
        if(operators.hasOwnProperty($type) && Object.keys(operators[$type]).length)
        {
            $search.operators = operators[$type];
            $search.operator = Object.keys($search.operators)[0];
        }
        else
        {
            $search.operators = {};
            $search.operator = '=';
        }
    };

    const doesSearchGroupContainDateFilter = (searchGroup) => {
        for(const option of searchGroup.options) {
            // technically this could work for numbers but we're only using the function for dates so it's probably fine
            if(option.operator === 'between') {
                return true;
            }
        }
        return false;
    };

    return (<>
        {searchTerms.map((searchGroup, searchGroupKey) => (<React.Fragment key={searchGroupKey}>

        <Card sx={{mb: 2.5, borderRadius: 'sm'}}>
            <CardOverflow sx={{ bgcolor: 'background.level2' }}>
                <CardActions sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    py: 1,
                }}>
                    <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flex: 1,
                    gap: 1,
                }}>
                    <Typography fontWeight={'bold'} color="black">Filter {(searchGroupKey + 1)}: </Typography>
                        <MaestroSelect
                            options={objects}
                            getOptionLabel={(option)=>option.name}
                            getOptionValue={(option)=>option.slug}
                            value={searchGroup.object}
                            onChange={(selected) => setSearchGroupType(searchGroup, selected)}
                        />
                    </Box>
                    <Box>
                        <Tooltip title='Remove Search Group'>
                            <IconButton
                                // color="danger"
                                // size={'sm'}
                                color="neutral"
                                size="sm"
                                variant="outlined"

                                sx={theme => ({
                                    borderRadius: 'sm',
                                    color: 'white',
                                    bgcolor: 'background.surface',
                                    ':hover': {
                                        bgcolor: theme.palette.danger[600],
                                    },
                                })}
                                type="button"
                                onClick={() => removeSearchGroup(searchGroup)}
                            >
                                <RemoveRoundedIcon/>
                            </IconButton>
                            {/* <button className="btn btn-ss btn-default btn-remove" type="button" onClick={() => removeSearchGroup(searchGroup)}><i className="icon-minus"></i></button> */}
                        </Tooltip>
                    </Box>
                </CardActions>
            </CardOverflow>
            <CardContent>
                <Box>
                    {searchGroup.options.length === 0 && (
                        <div className="search-group-content" >
                            <div className="wrapper">
                                <em>Select your type of search to proceed.</em>
                            </div>
                        </div>
                    )}

                    {searchGroup.options.length > 0 && (
                        <div className="search-group-content">
                            {searchGroup.options.map((search, searchIndex) => {
                                // loading saved search
                                let selectedSearchOption;
                                if((search.type === 'created_at' || search.type === 'updated_at') && searchGroup.object.value === 'volunteer-hours') {
                                    selectedSearchOption = 'volunteered_at';
                                } else if((search.type === 'created_at' || search.type === 'updated_at') && searchGroup.object.value === 'donations') {
                                    selectedSearchOption = 'received';
                                } else {
                                    selectedSearchOption = searchGroup.possibleOptions.filter(obj => obj.value === search.type)[0];
                                }

                                if(typeof selectedSearchOption === 'undefined') {
                                    console.warn(searchGroup.object);
                                    console.warn(search.type);
                                }
                                {/* console.log('=====selectedSearchOption====='); */}
                                {/* console.log(selectedSearchOption); */}
                                //searchGroup.possibleOptions.filter
                                return (<React.Fragment key={searchIndex}>
                                <div className={`option ${searchIndex % 2 != 0 ? 'even' : ''}`}>
                                    {searchIndex !== 0 && (
                                        <div className="and-text">
                                            <span>and</span>
                                        </div>
                                    )}

                                    <div className="type">
                                        <MaestroSelect
                                            options={searchGroup.possibleOptions}
                                            value={selectedSearchOption}
                                            onChange={(selected) => {
                                                search.type = selected.value;

                                                let selectedType = selected.hasOwnProperty('type') ? selected.type : 'contains';
                                                search.value = '';
                                                getOperators(search, selectedType);
                                                update();
                                            }}
                                        />
                                    </div>
                                    {search.operators && Object.keys(search.operators).length > 0 && selectedSearchOption.type !== 'date' && selectedSearchOption.type !== 'relative_date' && (
                                        <div className="operator">
                                            <MaestroSelect
                                                options={objectToSelectOptions(search.operators)}
                                                value={search.operator}
                                                onChange={(selected) => {
                                                    // console.log(selected);
                                                    search.operator = selected;//.value;//[0];
                                                    update();
                                                }}
                                            />
                                        </div>
                                    )}

                                    {search.type && (
                                    <div className="value">
                                        {/* Number */}
                                        {(selectedSearchOption.type === 'number' || selectedSearchOption.type === 'number_between') && (
                                            <div className="search-type-date">
                                                <div className="start-date">
                                                    <Input
                                                        type={'number'}
                                                        step={selectedSearchOption.hasOwnProperty('step') ? selectedSearchOption.step : null}
                                                        value={search.value}
                                                        onChange={(event) => {search.value = event.target.value; update()}}
                                                        sx={{
                                                        bgcolor: '#fff'
                                                    }}
                                                    />
                                                </div>

                                                {search.operator && search.operator.value === 'between' && (<>
                                                    <div className="between-text">
                                                        <em>to</em>
                                                    </div>

                                                    <div className="end-date">
                                                        <Input
                                                            type={'number'}
                                                            step={selectedSearchOption.hasOwnProperty('step') ? selectedSearchOption.step : null}
                                                            value={search.value2}
                                                            onChange={(event) => {search.value2 = event.target.value; update()}}
                                                            sx={{
                                                        bgcolor: '#fff'
                                                    }}
                                                        />
                                                    </div>
                                                </>)}
                                            </div>
                                        )}

                                        {/* String */}
                                        {selectedSearchOption.type === 'contains' && (
                                            <FormControl>
                                                <Input
                                                    type={'text'}
                                                    value={search.value}
                                                    onChange={(event) => {search.value = event.target.value; update()}}
                                                    sx={{
                                                        bgcolor: '#fff'
                                                    }}
                                                />
                                                {search.operator && <FormHelperText>Use % to simulate a "{search.operator.value === 'contains' ? 'has' : 'does not have'}" search</FormHelperText>}
                                            </FormControl>
                                        )}

                                        {/* Date & Relative Date */}
                                        {selectedSearchOption.type === 'date' && (<em>{`(Within selected date range: ${format(dateRange.startDate, 'MM/dd/yyyy')} – ${format(dateRange.endDate, 'MM/dd/yyyy')})`}</em>)}
                                        {selectedSearchOption.type === 'relative_date' && (<em>{`(Within selected date range: ${format(dateRange.startDate, 'MM/dd')} – ${format(dateRange.endDate, 'MM/dd')}. Note that only month and day are utilizied)`}</em>)}
                                        {/* relative_date */}

                                        {/*
                                        {(selectedSearchOption.type === 'date' || selectedSearchOption.type === 'relative_date') && (
                                            <div className="search-type-date">
                                                <div className="start-date">
                                                    <DatePicker
                                                        locale="en-US"
                                                        format={selectedSearchOption.type === 'relative_date' ? 'MM/dd' : null}
                                                        value={search.value}
                                                        onChange={(event) => {search.value = event; update()}}
                                                    />
                                                </div>

                                                {search.operator && search.operator.value === 'between' && (<>
                                                    <div className="between-text">
                                                        <em>to</em>
                                                    </div>

                                                    <div className="end-date">
                                                        <DatePicker
                                                            locale="en-US"
                                                            format={selectedSearchOption.type === 'relative_date' ? 'MM/dd' : null}
                                                            value={search.value2}
                                                            onChange={(event) => {search.value2 = event; update()}}
                                                        />
                                                    </div>
                                                </>)}
                                            </div>
                                        )}
                                        */}

                                        {/* Standard drop downs (contacts, properties, etc.) */}
                                        {selectedSearchOption.type === 'select' && (
                                            <MaestroSearchSelect selectedCommunities={selectedCommunities} searchOption={selectedSearchOption} object={selectedSearchOption.value} value={search.value} onChange={(event) => {search.value = event; update()}} />
                                        )}

                                        {/* Involvements */}
                                        {selectedSearchOption.type === 'involvement' && (<>
                                            <MaestroSearchSelect selectedCommunities={selectedCommunities}
                                                searchOption={selectedSearchOption}
                                                object={'involvement'}
                                                value={search.value}
                                                onChange={(event) => {search.value = event; update()}}
                                                value2={search.value2}
                                                onChange2={(event) => {search.value2 = event; update()}}
                                            />
                                            {searchGroup.object.value === 'volunteer-hours' && search.value2 && doesSearchGroupContainDateFilter(searchGroup) === false && (
                                                <Box mt='1'>
                                                    <small><em>Note: this will return volunteer hours for all contacts who have this involvement, but the results are not constrainted to that date. If you want the specific date range, add a "date volunteered" filter.</em></small>
                                                    <Button
                                                        mt='1'
                                                        size={'sm'}
                                                        startDecorator={<AddRoundedIcon/>}
                                                        onClick={() => {
                                                            let searchObject = {
                                                                type: 'volunteered_at',
                                                                operator: 'between',
                                                                value: null,
                                                                value2: null,
                                                            }

                                                            addSearch(searchGroup, searchObject)
                                                        }}
                                                        width='100%'
                                                    >Add Date Filter</Button>
                                                </Box>
                                            )}
                                        </>)}

                                    </div>
                                    )}

                                    <div className="remove-action">
                                        <Tooltip title='Remove Search Parameter'>
                                            <IconButton
                                                color="neutral"
                                                size={'sm'}
                                                type="button"
                                                variant="outlined"
                                                sx={theme => ({
                                                    // bgcolor: theme.palette.danger[300],
                                                    '--IconButton-size': '1.5rem',
                                                    color: theme.palette.danger[800],
                                                    bgcolor: 'background.level1',
                                                    // fontSize: '0.8rem',
                                                    ':hover': {
                                                        color: 'white',
                                                        bgcolor: theme.palette.danger[600],
                                                    },
                                                })}
                                                onClick={()=>removeSearch(searchGroup, search)}
                                            >
                                                <RemoveRoundedIcon/>
                                            </IconButton>
                                            {/* <button className="btn btn-sm btn-default btn-remove" type="button" ><i className="icon-minus"></i></button> */}
                                        </Tooltip>
                                    </div>
                                    {searchGroup.options.length-1 == searchIndex && (
                                    <div className="add-action">
                                        <Tooltip title='New Search'>
                                            <IconButton
                                                color="neutral"
                                                size={'sm'}
                                                type="button"
                                                variant="outlined"
                                                sx={theme => ({
                                                    // bgcolor: theme.palette.danger[300],
                                                    '--IconButton-size': '1.5rem',
                                                    color: theme.palette.danger[800],
                                                    bgcolor: 'background.level1',
                                                    // fontSize: '0.8rem',
                                                    ':hover': {
                                                        color: 'white',
                                                        bgcolor: theme.palette.danger[600],
                                                    },
                                                })}
                                                onClick={()=>addSearch(searchGroup)}
                                            >
                                                <AddRoundedIcon/>
                                            </IconButton>
                                            {/* <button className="btn btn-sm btn-default btn-new" type="button" onClick={()=>addSearch(searchGroup)}><i className="icon-plus"></i></button> */}
                                        </Tooltip>
                                    </div>
                                    )}
                                </div>
                            </React.Fragment>)
                            })}
                        </div>
                    )}


                </Box>
            </CardContent>
        </Card>

            {/*
            <div className="panel widget">
                <div key={searchGroupKey} className="search-group wrapper">
                    <Flex className="panel-subheading1">
                        <Box flex='1'>
                            Search Object
                        </Box>
                        <Box>
                            <span className="btn-group">
                                <button className="btn btn-ss btn-default btn-remove" type="button" ng-click="removeSearchGroup(searchGroup)" uib-tooltip="Remove Search Group" tooltip-placement="bottom" tooltip-append-to-body="true"><i className="icon-minus"></i></button>
                            </span>
                        </Box>

                    </Flex>

                </div>
            </div>
            */}
        </React.Fragment>))}
        {/* {searchTerms.length === 0 && ( */}
            <div className="wrapper-v">
                <Button
                    startDecorator={<AddRoundedIcon/>}
                    onClick={addSearchGroup}
                    width='100%'
                    color="neutral"
                    size="sm"
                >Add Search Filter</Button>
            </div>
        {/* )} */}
    </>);
};

export default MaestroMultiSearch;
